export const UPDATE_CONTACT_API_ENDPOINT = '/booking-portal/ContactV2/UpdateContact';
